import { Step } from "react-joyride";

export const tourSteps: Step[] = [
    {
        target: ".beginner-tour-timeline",
        title: "This highlighted area is the timeline. This is where we will create music!",
        content: undefined,
        disableBeacon: true,
        hideBackButton: true,
        hideCloseButton: true,
        showSkipButton: true
    },
    {
        target: ".beginner-tour-song-library",
        title: "Select a song!",
        content: undefined,
        disableBeacon: true,
        styles:{
            buttonNext: {
                display: 'none',
            },
            tooltipContent: {
                padding: '0px',
            }
        },
        hideBackButton: true,
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: true
    },
    {
        target: ".beginner-tour-get-stems",
        title: 'Drag a piece of music into the timeline below!',
        content: undefined,
        disableBeacon: true,
        styles:{
            buttonNext: {
                display: 'none',
            },
            tooltipContent: {
                padding: '0px',
            }
        },
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: true
    },
    {
        target: ".beginner-tour-timeline",
        title: "Drop your selection here.",
        content: undefined,
        disableBeacon: true,
        styles:{
            buttonNext: {
                display: 'none',
            },
            tooltipContent: {
                padding: '0px',
            }
        },
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: false
    },
    {
        target: ".beginner-tour-item",
        title: "Now we have that music in the timeline.",
        content: undefined,
        disableBeacon: true,
        styles:{
            tooltipContent: {
                padding: '0px',
            }
        },
        hideBackButton: true,
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: true
    },
    {
        target: ".beginner-tour-play-button",
        title: "Press play to hear what we have so far.",
        content: undefined,
        disableBeacon: true,
        styles:{
            buttonNext: {
                display: 'none',
            },
            buttonSkip: {
                display: 'none',
            },
            tooltipContent: {
                padding: '0px',
            }
        },
        hideBackButton: true,
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: true
    },
    {
        target: ".beginner-tour-send-to-musicians-button",
        title: "How do you think it sounds?",
        content: "When you have a project that you like, click this button to send it to real musicians who will record a music video of your song for you!",
        disableBeacon: true,
        hideFooter: true,
        hideBackButton: true,
        hideCloseButton: true,
        spotlightClicks: true,
        showSkipButton: true,
    }
];
